// @flow

import * as React from 'react'
import { Container, Segment, Button } from 'semantic-ui-react'
import { Form, Fields, Validators, formActions } from 'react-redux-components'
import { store } from '../store/index'

import { type Doctor } from '../store/manage-panel'

type Props = {|
  loadedRecord: Array<string>,
  pristine: boolean,
  onSubmit: (doctor: Doctor) => void,
  onCancel: () => void,
|}

class PanelForm extends React.Component<Props> {
  customFields = []
  validators = {
    _id: { required: Validators.required },
    cognome: { required: Validators.required },
    nome: { required: Validators.required },
    citta: { required: Validators.required },
    provincia: { required: Validators.required },
    regione: { required: Validators.required },
    cap: { required: Validators.required },
    specializzazione: { required: Validators.required },
  }

  componentWillMount() {
    let initialFormValue = {}
    let standardFields = [
      '_id',
      'cognome',
      'nome',
      'area',
      'indirizzo',
      'citta',
      'provincia',
      'regione',
      'cap',
      'specializzazione',
      'stato_f2f',
      'stato_phone',
      'stato_web',
    ]
    for (let field of this.props.loadedRecord) {
      initialFormValue[field] = ''
      if (standardFields.indexOf(field) === -1) {
        let label = field.charAt(0).toUpperCase() + field.slice(1)
        this.customFields.push(
          <div className="five wide column" key={'col-' + field}>
            <Fields.TextInput label={label} model={'.' + field} />
          </div>
        )
      }
    }

    store.dispatch(formActions.load('panel.form', initialFormValue))
  }

  render() {
    let TextInput = Fields.TextInput
    let stdErrMsg = { required: 'Campo obbligatorio' }
    return (
      <Container>
        <Form onSubmit={this.props.onSubmit} model="panel.form" dimmable={true} validators={this.validators}>
          <Segment color="orange" secondary>
            <div className="ui grid" style={{ margin: '0 2ex' }}>
              <div className="four wide column">
                <TextInput label="ID" model="._id" disabled={true} errorMessages={stdErrMsg} />
              </div>
              <div className="six wide column">
                <TextInput label="Cognome" model=".cognome" errorMessages={stdErrMsg} />
              </div>
              <div className="six wide column">
                <TextInput label="Nome" model=".nome" errorMessages={stdErrMsg} />
              </div>

              <div className="sixteen wide column" style={{ paddingTop: 0, paddingBottom: '1rem' }} />

              <div className="five wide column">
                <TextInput label="Area" model=".area" />
              </div>

              <div className="six wide column">
                <TextInput label="Indirizzo" model=".indirizzo" errorMessages={stdErrMsg} />
              </div>

              <div className="five wide column">
                <TextInput label="Città" model=".citta" errorMessages={stdErrMsg} />
              </div>
              <div className="seven wide column">
                <TextInput label="Provincia" model=".provincia" errorMessages={stdErrMsg} />
              </div>
              <div className="six wide column">
                <TextInput label="Regione" model=".regione" errorMessages={stdErrMsg} />
              </div>

              <div className="sixteen wide column" style={{ paddingTop: 0, paddingBottom: '1rem' }} />

              <div className="three wide column">
                <TextInput label="CAP" model=".cap" errorMessages={stdErrMsg} />
              </div>
              <div className="nine wide column">
                <TextInput label="Specializzazione" model=".specializzazione" errorMessages={stdErrMsg} />
              </div>
              <div className="five wide column">
                <Fields.ComboBox
                  label="Stato F2F"
                  model=".stato_f2f"
                  options={[
                    { value: '', text: '--' },
                    { value: 'abilitato', text: 'Abilitato' },
                    { value: 'disabilitato', text: 'Disabilitato' },
                  ]}
                />
              </div>
              <div className="five wide column">
                <Fields.ComboBox
                  label="Stato PHONE"
                  model=".stato_phone"
                  options={[
                    { value: '', text: '--' },
                    { value: 'abilitato', text: 'Abilitato' },
                    { value: 'disabilitato', text: 'Disabilitato' },
                  ]}
                />
              </div>
              <div className="five wide column">
                <Fields.ComboBox
                  label="Stato WEB"
                  model=".stato_web"
                  options={[
                    { value: '', text: '--' },
                    { value: 'abilitato', text: 'Abilitato' },
                    { value: 'disabilitato', text: 'Disabilitato' },
                  ]}
                />
              </div>

              <div className="sixteen wide column" style={{ paddingTop: 0, paddingBottom: '1rem' }} />
              {this.customFields}
              <div className="sixteen wide column" style={{ paddingTop: 0, paddingBottom: '1rem' }} />
            </div>

            <div className="ui grid" style={{ marginTop: '7ex' }}>
              <div className="two column row">
                <div className="right floated column">
                  <Button
                    icon="save"
                    content="Salva"
                    labelPosition="left"
                    primary
                    disabled={this.props.pristine}
                    className="right floated"
                    type="submit"
                    style={{ width: '18ex' }}
                  />
                  <Button
                    type="button"
                    icon="cancel"
                    content="Annulla"
                    labelPosition="left"
                    className="right floated"
                    onClick={this.props.onCancel}
                    style={{ width: '18ex' }}
                  />
                </div>
              </div>
            </div>
          </Segment>
        </Form>
      </Container>
    )
  }
}

export default PanelForm



// WEBPACK FOOTER //
// ./src/panels/panel-form.js